import React, { useEffect, useState, useRef } from 'react';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';

import { useParams } from "react-router-dom";




function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);

  }

export default function ConfigValue() {
    let { id } = useParams();
    const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));
    const [loading, setLoading] = useState(true);

    const [data, setData] = useState({ id: 0, key: "Loading", definitionId: "Loading", key: "Loading", displaykey: "Loading", order: "Loading", createdAt: "Loading", updatedAt: "Loading" });

    // Toast and ConfirmDialog
    const toast = useRef(null);

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getDataUserToken}`,
    };

    const [userDetails, setUserDetails] = useState(             // eslint-disable-line no-unused-vars
        getSessionStorageOrDefault('userDetails', null)
    );

    const canView = (userDetails) => {
        if (userDetails) {
            return userDetails.permissions.some(e => e.codename === 'view_workflowconfigmanagement');
        }
        return false;
    }


    useEffect(() => {

        fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/configvalue/${id}`, {
            headers,
            }).then((res) => res.json())
            .then(data => {
                setData(data);
            }
            ).catch((error) => {
                console.log('Error in getting ConfigKeys', error);
            });

        setLoading(false);
    }, [])  // eslint-disable-line react-hooks/exhaustive-deps

    return (

        <>
        { canView(userDetails) && 
            <div className="surface-card p-4 shadow-2 border-round">
            <Toast ref={toast} />
            <ConfirmDialog group="templating" />
            <div className="font-medium text-3xl text-900 mb-3">ConfigValue Details</div>
      
            <ul className="list-none p-0 m-0">
                <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                    <div className="text-500 w-6 md:w-2 font-medium">ID</div>
                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.id}</div>
                </li>

                <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                    <div className="text-500 w-6 md:w-2 font-medium">ConfigKeyId</div>
                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.ConfigKeyId}</div>
                </li>

                <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                    <div className="text-500 w-6 md:w-2 font-medium">value</div>
                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.value}</div>
                </li>

                <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                    <div className="text-500 w-6 md:w-2 font-medium">Display Value</div>
                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.DisplayValue}</div>
                </li>

                <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                    <div className="text-500 w-6 md:w-2 font-medium">Ceated At</div>
                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.createdAt}</div>
                </li>
                
                <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                    <div className="text-500 w-6 md:w-2 font-medium">Last Updated</div>
                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.updatedAt}</div>
                </li>
            </ul>
            </div>
        }

        { !canView(userDetails) && <div className="font-medium text-3xl text-900 mb-3">You do not have permission to view this page.</div> }
        </>
    );
}
